module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-picker",
    attrs: {
      "id": "country-selector"
    }
  }, [(_vm.getIsLoadingGeography) ? _c('div', [_vm._v("Loading")]) : _c('multiselect', {
    staticClass: "country-picker__control",
    class: [_vm.customClass, {
      'country-picker--error': _vm.error
    }],
    attrs: {
      "options": _vm.countryOptions,
      "allowEmpty": _vm.allowEmpty,
      "multiple": false,
      "group-values": "allCountries",
      "showLabels": false,
      "group-label": "groupName",
      "placeholder": _vm.placeholder,
      "track-by": "id",
      "label": "name",
      "openDirection": _vm.openDirection,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6314892d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6314892d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/CountryPicker.vue
// module id = 1287
// module chunks = 0